/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import React, { SetStateAction } from "react";

import { useTranslation } from "react-i18next";

import Dialog from "@/components/Dialog/Dialog";
import { DialogWidth } from "@/components/Dialog/types/enums";
import DialogActions from "@/shared/components/buttons/DialogActions";

import { CompanyNameObject } from "../types";

interface MoveCompanyConfirmDialogProps {
  isLoading: boolean;
  isConfirmDialogOpen: boolean;
  companyNameObject: CompanyNameObject;
  setIsConfirmDialogOpen: (value: SetStateAction<boolean>) => void;
  handleCreateChildSubmit: () => Promise<void>;
}

const MoveCompanyConfirmDialog = ({
  isLoading,
  isConfirmDialogOpen,
  companyNameObject,
  setIsConfirmDialogOpen,
  handleCreateChildSubmit
}: MoveCompanyConfirmDialogProps) => {
  const { t } = useTranslation();

  const handleClose = () => setIsConfirmDialogOpen(false);

  const { sourceCompany, targetCompany } = companyNameObject;

  return (
    <Dialog
      data-testid="move-company-confirm-dialog"
      title={t(`Dialog##move company##confirmation dialog##are you sure`)}
      description={t(`Dialog##move company##confirmation dialog##description`, {
        sourceCompany,
        targetCompany
      })}
      extendToMaxWidth
      width={DialogWidth.TinyWidth}
      css={css({
        "& .MuiDialog-paper": {
          minWidth: DialogWidth.TinyWidth
        }
      })}
      open={isConfirmDialogOpen}
      close={handleClose}
      submit={handleCreateChildSubmit}
      actions={
        <div
          css={css({
            display: "flex",
            flexDirection: "column-reverse",
            gap: "8px"
          })}
        >
          <DialogActions
            onClose={handleClose}
            isLoading={isLoading}
            isreadyToConfirm={true}
            confirmationButtonText={t("Button##yes")}
            confirmationButtonTestId="confirm-move-company-button"
            cancelButtonText={t("Button##close")}
            cancelButtonTestId="close-confirm-move-company"
          />
        </div>
      }
    />
  );
};

export default MoveCompanyConfirmDialog;
